import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_next",
  "use": "micro_next-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_next\"><path fill-rule=\"evenodd\" d=\"M2.5 1.438V0l5 4.5-5 4.5V7.562L6 4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol